import type { QuoteBudgetEntryOptions } from "../types";

/** 展开一天的真实城市，单日行程保留首尾；空城市仍保留供确认阶段阻断。 */
export function manualBusDayRegions(day: NonNullable<QuoteBudgetEntryOptions["itineraryDays"]>[number] | undefined) {
  return day?.regions?.length ? day.regions : [day ?? {}];
}
